module.exports = __webpack_public_path__ + "img/120.d93525b1.jpg";